mainApp.component('planSiteStats', {
    templateUrl: '/public/components/plan-site-stats.component.html',
    bindings: {
        siteStats: '='
    },
    controller: function ($scope){
    }
});